import { render, staticRenderFns } from "./tab-container-alter-hist.vue?vue&type=template&id=44b7c644&scoped=true&lang=pug&"
import script from "./tab-container-alter-hist.vue?vue&type=script&lang=ts&"
export * from "./tab-container-alter-hist.vue?vue&type=script&lang=ts&"
import style0 from "./tab-container-alter-hist.vue?vue&type=style&index=0&id=44b7c644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b7c644",
  null
  
)

export default component.exports